import React, { useContext } from 'react';
import moment from 'moment';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import {
  SelectOption,
  UserBriefInfo,
  Property,
  CheckList,
  CheckListAction,
  TAssignmentChecklist,
  QuesInfo,
  ActivityLogInfo,
  TitleCompanyType,
  TransactionPropTypes,
  PaymentProps,
  PropertyDetailsProps,
  TaxCheckListProps,
  StateProps,
  PropertyProps,
  UserTypeOptions,
  SellerBuyerInfo,
  defaultUserOption,
  emailPattern,
} from '@app/types';
import { geocodeByPlaceId } from 'react-places-autocomplete';
import { useLocation } from '@app/utils';
import { AuthContext } from '@app/providers';
import {
  SecondaryHeader,
  Input,
  Select,
  TextArea,
  Toast,
  Button,
  CurrencyInput,
  Icon,
  Dialog,
} from '@app/components';
import {
  BackgroundContainer,
  Container,
  ListView,
  ListContainer,
  Title,
  SelectItem,
  SelectLabel,
  InfoBox,
  PropertyContainer,
  PropertyBox,
  InputContainer,
  InputCard,
  PrimaryInputCard,
  PrimaryInfoBox,
  SecondaryInputCard,
  InvolvedContainer,
  Seperator,
  BuyerContainer,
  Heading,
  SellerContainer,
  ProUserContainer,
  PersonTypeCard,
  SecondarySeperator,
  CheckListContainer,
  CheckListBox,
  PrimarySelectLabel,
  ErrorMessage,
  Loader,
  Star,
  SelectErrorMessage,
  StateInputCard,
  SaveButtonBox,
  ButtonItem,
  CancelButton,
  InvolvedHeader,
  DocumentContainer,
  PaymentDueContainer,
  AddressContainer,
  MapContainer,
  MlsLink,
  ModalContent,
} from '@app/modules/transaction-form/transactions-form-components';
import SideNav from './transactions-form-sidenav';
import {
  useCreateTransactionMutation,
  useGetTransactionQuery,
  useEditTransactionMutation,
  useGetTitleCompanies,
  useGetProfessionalTypes,
  useGetAllActiveStates,
  useGetActiveMunicipalitiesQuery,
  useGetProperties,
} from '@app/graphql';
import Documents from './documents';
import { DashedSeperator } from '../transaction-details/transactions-details-components';
import { UploadDocType } from '@app/types/documents';
import { s3, s3BucketName } from '@app/providers/aws';
import PaymentDue from '../payment-due/payment-due';
import { taxCalculation } from '@app/utils/tax-calculation';
import {
  checkEditTaskPermission,
  editTransaction,
} from '@app/utils/permissions';
import { CountiesProps } from '@app/types/municipalities';
import ProfessionalUsers from '@app/modules/transaction-form/professionalUsers';
import SellerBuyerDetails from './seller-buyer-details';

type checkListUserObj = SelectOption & {
  email?: string;
};

type MunicipalityOption = SelectOption & any;
type TitleCompanyOption = SelectOption & any;
type DropdownType = {
  type: string;
  show: boolean;
};

const personTypeOptions = [
  { value: 'Attorney(Buy)', label: 'Attorney (Buy)' },
  { value: 'Attorney(Sell)', label: 'Attorney (Sell)' },
  { value: 'Realtor(Buy)', label: 'Realtor (Buy)' },
  { value: 'Realtor(Sell)', label: 'Realtor (Sell)' },
];

const defaultSelectOption = {
  label: 'Please Select',
  value: '',
};

let defCreatorType = '';
let thisTransaction: any;
let activityLog: ActivityLogInfo[] = [];
let thisTransactionStr: any = '';
let showed: boolean = false;

export default function TranscationForm() {
  const { navigate } = useLocation();
  const { transactionId }: TransactionPropTypes = useParams();
  const [counties, setCounties] = React.useState<CountiesProps[]>([]);
  const [transferTaxAmount, setTransaferTaxAmount] = React.useState('');
  const [showWarning, setShowWarning] = React.useState<boolean>(false);
  const [professionalUsers, setProfessionalUsers] = React.useState<
    UserTypeOptions[]
  >([]);
  const [profUserOptions, setProfUserOptions] = React.useState<
    UserTypeOptions[]
  >([]);
  const {
    loading: propertiesLoading,
    data: propertiesData,
  } = useGetProperties();
  const {
    loading: transactionDetailsLoading,
    data: transactionDetails,
  } = useGetTransactionQuery({
    id: transactionId ? transactionId : '',
    offSetData: new Date().getTimezoneOffset().toString(),
  });

  const { register, errors, handleSubmit, formState } = useForm();
  const { isSubmitted } = formState;
  const { userInfo }: any = useContext(AuthContext);
  const [getMunicipalitiesByState] = useGetActiveMunicipalitiesQuery();
  const {
    loading: companiesLoading,
    data: companiesData,
  } = useGetTitleCompanies();
  const { data: typesData, loading: typesLoading } = useGetProfessionalTypes();
  const [createTransaction] = useCreateTransactionMutation();
  const [editTransactionDetails] = useEditTransactionMutation();
  const [saving, updatesaving] = React.useState(false);
  const [isError, setIsError] = React.useState(false);
  const [disabled, updatedisabled] = React.useState(false);
  const [showProdropDown, setShowProDropdown] = React.useState({
    show: false,
    index: 0,
  });
  const [showToast, setShowToast] = React.useState(false);
  const [toastMessage, updateToastMessage] = React.useState('');
  const [transactionStatus, setTransactionStatus] = React.useState<string>('');
  const [documents, updateDocuments] = React.useState<any>([]);
  const [removedDocs, updateRemovedDocs] = React.useState<UploadDocType[]>([]);
  const [municipalityList, setMunicipalityList] = React.useState<
    MunicipalityOption[]
  >([]);
  const [assignmentUserList, setAssignmentUserList] = React.useState<
    checkListUserObj[]
  >([]);
  const [municipalityData, setMunicipalityData] = React.useState<
    MunicipalityOption
  >(defaultSelectOption);
  const [taxRate, setTaxRate] = React.useState<string>('');
  const [creatorType, setCreatorType] = React.useState<SelectOption>(
    defaultSelectOption,
  );
  const [titleCompanies, updateTitleCompanies] = React.useState<
    TitleCompanyOption[]
  >([]);
  const [propertyInfo, setPropertyInfo] = React.useState<Property>({
    location: '',
    address: '',
    city: '',
    stateId: '',
    state: defaultSelectOption.value || 'IL',
    zipCode: '',
    latitude: 0,
    longitude: 0,
    countyId: '',
  });
  const [county, setCounty] = React.useState<SelectOption>(defaultSelectOption);
  const [propertyDetails, setPropertyDetails] = React.useState<
    PropertyDetailsProps
  >({
    type: defaultSelectOption,
    purchasePrice: '',
    closingDate: '',
    notes: '',
    pin: '',
  });
  const editTransactionPermission = transactionId
    ? editTransaction(userInfo, transactionId)
    : true;
  const [mlsLink, setMlsLink] = React.useState('');
  const propertyInfoRef = React.useRef(propertyInfo);
  const [titleCompany, updateTitleCompany] = React.useState(
    defaultSelectOption,
  );
  const [sellers, setSellers] = React.useState<SellerBuyerInfo[]>([
    {
      address: '',
      email: '',
      name: '',
      phone: '',
      showEntityCheckbox: true,
      showRadioButtons: false,
      subDetails: {
        isEntity: false,
        isIndividual: false,
      },
    },
  ]);
  const [buyers, setBuyers] = React.useState<SellerBuyerInfo[]>([
    {
      address: '',
      email: '',
      name: '',
      phone: '',
      showEntityCheckbox: true,
      showRadioButtons: false,
      subDetails: {
        isEntity: false,
        isIndividual: false,
      },
    },
  ]);
  const [uploadedDocs, updateUploadedDocs] = React.useState<any>([]);
  const [payments, setPayments] = React.useState<PaymentProps[]>([]);
  const [assignmentCheckList, setAssignmentCheckList] = React.useState<
    TAssignmentChecklist
  >({});
  const [isTaxVerified, setIsTaxVerified] = React.useState(false);
  const [showTaxModal, setShowTaxModal] = React.useState(false);
  const [, setShowDropdown] = React.useState<DropdownType>({
    type: '',
    show: false,
  });
  const { loading: stateLoading, data: stateData } = useGetAllActiveStates();
  const [states, setStates] = React.useState<StateProps[]>([]);
  const [selectedState, setSelectedState] = React.useState<StateProps>({
    value: '',
    label: 'Please Select',
    _id: '',
    status: '',
  });
  const [propertyOptions, setPropertyOptions] = React.useState([]);
  const proDrodownRef: any = React.useRef(null);
  let autocomplete: google.maps.places.Autocomplete;
  function handleClickOutside(e: any) {
    if (
      showProdropDown &&
      proDrodownRef.current &&
      !proDrodownRef.current.contains(e.target)
    ) {
      setShowProDropdown({ show: false, index: 0 });
    }
  }
  document.addEventListener('click', handleClickOutside);
  var southWest = new google.maps.LatLng(36.970298, -91.5130789);
  var northEast = new google.maps.LatLng(42.5083379, -87.01993499999999);
  var defaultBounds = new google.maps.LatLngBounds(southWest, northEast);
  const illinoisBounds = {
    north: 42.5083379,
    south: 36.970298,
    east: -87.01993499999999,
    west: -91.5130789,
  };

  React.useEffect(() => {
    if (!typesLoading && typesData) {
      const { getAllActiveTransactionCreateProfessionalUserTypes } = typesData;
      if (
        getAllActiveTransactionCreateProfessionalUserTypes &&
        getAllActiveTransactionCreateProfessionalUserTypes.success
      ) {
        const {
          professionalUserTypes,
        } = getAllActiveTransactionCreateProfessionalUserTypes;
        if (professionalUserTypes && professionalUserTypes.length) {
          setProfUserOptions(
            professionalUserTypes.map((profUser: UserTypeOptions) => {
              return {
                ...profUser,
                user: defaultUserOption,
                profUserTypeId: profUser._id,
              };
            }),
          );
          if (!transactionId) {
            setProfessionalUsers(
              professionalUserTypes
                .filter((proUser: UserTypeOptions) => {
                  return (
                    proUser.key !== 'attorney_buy' &&
                    proUser.key !== 'attorney_sell'
                  );
                })
                .map((user: UserTypeOptions) => {
                  return {
                    ...user,
                    user: defaultUserOption,
                    profUserTypeId: user._id,
                  };
                }),
            );
          }
        }
      }
    }
  }, [typesLoading, typesData, transactionId]);

  React.useEffect(() => {
    const options = {
      fields: ['address_components', 'geometry'],
      strictBounds: true,
      bounds: illinoisBounds,
      componentRestrictions: { country: ['us'] },
    };
    let input: any = document.getElementById('propertyAddress');
    if (input) {
      // eslint-disable-next-line
      autocomplete = new google.maps.places.Autocomplete(input, options);
      autocomplete.addListener('place_changed', fillInAddress);
    }
    // eslint-disable-next-line
  }, [document.getElementById('propertyAddress')]);

  React.useEffect(() => {
    if (
      !companiesLoading &&
      companiesData &&
      companiesData.getAllActiveTitleCompanies &&
      companiesData.getAllActiveTitleCompanies.success
    ) {
      const { titleCompanies } = companiesData.getAllActiveTitleCompanies;
      if (titleCompanies && titleCompanies.length) {
        updateTitleCompanies(
          titleCompanies.map((tC: TitleCompanyType) => {
            return {
              value: tC._id,
              label: tC.name,
            };
          }),
        );
      }
    }
  }, [companiesLoading, companiesData]);

  React.useEffect(() => {
    if (
      transactionId &&
      !transactionDetailsLoading &&
      transactionDetails.getTransactionDetails &&
      transactionDetails.getTransactionDetails.success
    ) {
      const {
        getTransactionDetails: { transaction },
      } = transactionDetails;
      activityLog = [];
      thisTransaction = { ...transaction };
      thisTransactionStr = JSON.stringify(thisTransaction);
      setTransactionStatus(transaction.status);
      const {
        property,
        creator,
        buyers,
        sellers,
        professionalUsers,
        assignmentChecklist,
        municipalityData,
        transactionDocuments,
        mlsLink,
        countyInfo,
        stateInfo,
      } = Object.assign({}, transaction);
      setCounty(countyInfo ? countyInfo : defaultSelectOption);
      setSelectedState(stateInfo);
      setPayments(transaction.transactionPayments);
      setMlsLink(mlsLink);
      updateUploadedDocs(
        transactionDocuments && transactionDocuments.length
          ? transactionDocuments
          : [],
      );
      updateDocuments(
        transactionDocuments && transactionDocuments.length
          ? transactionDocuments
          : [],
      );
      setPropertyInfo({
        ...property,
        type: {
          value: property.type,
          label: property.type,
        },
        zipCode: String(property.zipCode),
      });
      setPropertyDetails({
        ...property,
        type: {
          value: property.type,
          label: property.type,
        },
      });
      setMunicipalityData({
        ...municipalityData,
        value: transaction.municipalityId,
        label: municipalityData.name,
      });
      setCounties(
        municipalityData && municipalityData.counties
          ? municipalityData.counties
          : [],
      );
      if (
        municipalityData &&
        municipalityData.TaxCalculations &&
        municipalityData.TaxCalculations.rate
      ) {
        setTaxRate(municipalityData.TaxCalculations.rate);
      }
      buildAssignmentChecklist(municipalityData);
      if (property.latitude && property.longitude && property.address) {
        mapFormation(property.address, property.latitude, property.longitude);
      }
      defCreatorType = creator.type;
      setCreatorType({
        label: creator.type,
        value: creator.type,
      });
      updateTitleCompany({
        value: transaction.titleCompanyId,
        label: transaction.titleCompany,
      });
      setBuyers(buyers);
      setSellers(sellers.slice(0));
      if (assignmentChecklist && assignmentChecklist.verifyTaxCalculations) {
        setTaxDetails(assignmentChecklist.verifyTaxCalculations);
      }
      if (professionalUsers && professionalUsers.length) {
        setProfessionalUsers(
          professionalUsers.map((profUser: UserTypeOptions) => {
            let userDetails: UserBriefInfo = profUser.user;
            if (userDetails) {
              userDetails = {
                ...userDetails,
                name:
                  (userDetails.firstName ? userDetails.firstName : '') +
                  ' ' +
                  (userDetails.lastName ? userDetails.lastName : ''),
              };
            }
            return {
              ...profUser,
              value: profUser.profUserTypeId,
              label: profUser.type,
              user: !userDetails ? { new: true } : userDetails,
            };
          }),
        );
      }
      getMunicipalities(property.stateId);
      loadProUserList(professionalUsers, assignmentChecklist);
    }
    // eslint-disable-next-line
  }, [transactionId, transactionDetailsLoading, transactionDetails]);

  React.useEffect(() => {
    if (!stateLoading && stateData) {
      const { getAllActiveStates } = stateData;
      if (
        getAllActiveStates &&
        getAllActiveStates.success &&
        getAllActiveStates.states &&
        getAllActiveStates.states.length
      ) {
        setStates(
          getAllActiveStates.states.filter((state: StateProps) => {
            return state.label === 'Illinois';
          }),
        );
      }
    }
  }, [stateLoading, stateData]);

  React.useEffect(() => {
    if (!propertiesLoading && propertiesData) {
      const { getAllActivePropertyTypes } = propertiesData;
      if (
        getAllActivePropertyTypes &&
        getAllActivePropertyTypes.success &&
        getAllActivePropertyTypes.propertyTypes &&
        getAllActivePropertyTypes.propertyTypes.length
      ) {
        const { propertyTypes } = getAllActivePropertyTypes;
        setPropertyOptions(
          propertyTypes.map((property: PropertyProps) => {
            return { ...property, label: property.name, value: property.name };
          }),
        );
      }
    }
  }, [propertiesLoading, propertiesData]);

  const fillInAddress = () => {
    const place: any = autocomplete.getPlace();
    if (place && place.address_components) {
      const lat: number = place.geometry ? place.geometry.location.lat() : 0;
      const lng: number = place.geometry ? place.geometry.location.lng() : 0;
      setCityZip(place.address_components, lat, lng);
      setPropertyInfo({ ...propertyInfo, latitude: lat, longitude: lng });
      if (lat && lng) {
        mapFormation(propertyInfo.address, lat, lng);
      }
    }
  };

  async function setTaxDetails(taxData: TaxCheckListProps) {
    if (taxData && taxData.status) {
      setIsTaxVerified(taxData.status === 'COMPLETED' ? true : false);
    }
  }
  async function mapFormation(
    address: string,
    latitude: number,
    longitude: number,
  ) {
    const mapElement: any = document.getElementById('map');
    if (latitude && longitude && mapElement) {
      mapElement.style.display = 'block';
      const map = new google.maps.Map(mapElement as HTMLElement, {
        zoom: 15,
        center: { lat: latitude, lng: longitude },
        restriction: {
          latLngBounds: defaultBounds,
          strictBounds: true,
        },
      });
      new google.maps.Marker({
        position: { lat: latitude, lng: longitude },
        map,
        title: address,
      });
      map.panTo({ lat: latitude, lng: longitude });
      google.maps.event.addListener(map, 'click', function(event) {
        placeMarker(map, event);
      });
    }
  }

  async function placeMarker(map: any, location: any) {
    if (location && location.placeId && location.latLng) {
      await geocodeByPlaceId(location.placeId)
        .then(async results => {
          if (results && results.length) {
            const lat: number = results[0].geometry
              ? results[0].geometry.location.lat()
              : 0;
            const lng: number = results[0].geometry
              ? results[0].geometry.location.lng()
              : 0;
            await setCityZip(
              results[0].address_components
                ? results[0].address_components
                : '',
              lat,
              lng,
            );

            if (lat && lng) {
              await mapFormation(propertyInfo.address, lat, lng);
            }
          }
        })
        .catch(error => console.error(error));
    } else {
      const latLng = location.latLng;
      if (latLng) {
        await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latLng.lat()},${latLng.lng()}&key=AIzaSyC0wg5uNATQg9lg1I7pLhTDJmrRCwD-j8M`,
        )
          .then((response: any) => response.json())
          .then(async (data: any) => {
            const { results } = data;
            if (results && results.length) {
              const lat: number = latLng.lat();
              const lng: number = latLng.lng();
              await setCityZip(
                results[0].address_components
                  ? results[0].address_components
                  : '',
                lat,
                lng,
              );

              if (lat && lng) {
                await mapFormation(propertyInfo.address, lat, lng);
              }
            }
          })
          .catch((error: any) => {
            console.log(error);
          });
      }
    }
  }
  const loadProUserList = (
    professionalUsers: UserTypeOptions[],
    assignmentCheckListData: any,
  ) => {
    const proUserListMod = professionalUsers.map((proUser: UserTypeOptions) => {
      const { type = '', profUserTypeId = '', user } = proUser;
      const userName = user ? `${user.firstName} ${user.lastName}` : '';
      const userLabel = userName ? `${userName} - ${user && user.company}` : '';
      return {
        ...proUser,
        value: profUserTypeId,
        label: type,
        user: {
          ...user,
          label: userLabel,
          value: user && user.firebaseId ? user.firebaseId : '',
          name: userName,
        },
      };
    });
    regenerateChecklistAssignUsers(proUserListMod, assignmentCheckListData);
  };

  function afterRemove(docs: UploadDocType[], removedDoc: UploadDocType[]) {
    updateRemovedDocs(removedDoc);
    updateUploadedDocs(docs);
    updateDocuments(docs);
  }

  let docs: any = [];
  function getFiles(filesData: UploadDocType[]) {
    if (filesData && filesData.length) {
      docs = filesData.map((file: UploadDocType) => {
        return {
          title: file.title,
          docUrl: file.Location || file.docUrl,
          docKey: file.docKey,
          firebaseId:
            file.firebaseId ||
            (userInfo && userInfo.firebaseId ? userInfo.firebaseId : ''),
          notes: file.notes,
          docUniqueId: file.docUniqueId,
          docContentType: file.docContentType || '',
          documentType: file.documentType || '',
          otherDocumentType: file.otherDocumentType,
          uploadedDate: file.uploadedDate || moment(),
          uploadedBy: userInfo
            ? userInfo.firstName + ' ' + userInfo.lastName
            : '',
        };
      });
      updateUploadedDocs(docs);
      updateDocuments(docs);
    }
  }

  /**
   *
   * @param addressComponent address component of property
   */
  const setCityZip = (addressComponent: any, lat: number, lng: number) => {
    let zipcode: string = '';
    let city: string = '';
    let street: string = '';
    if (addressComponent) {
      for (const component of addressComponent as google.maps.GeocoderAddressComponent[]) {
        // @ts-ignore remove once typings fixed
        const componentType = component.types[0];
        switch (componentType) {
          case 'premise': {
            street = `${component.long_name}`;
            break;
          }
          case 'street_number': {
            street = street
              ? street + `,${component.long_name}`
              : component.long_name;
            break;
          }
          case 'route': {
            street = street
              ? street + `,${component.long_name}`
              : component.long_name;
            break;
          }
          case 'locality': {
            street = street
              ? street + `,${component.long_name}`
              : component.long_name;
            break;
          }
          case 'sublocality_level_2': {
            street = street
              ? street + `,${component.long_name}`
              : component.long_name;
            break;
          }
          case 'sublocality_level_1': {
            street = street
              ? street + `,${component.long_name}`
              : component.long_name;
            break;
          }
          case 'administrative_area_level_3': {
            street = street
              ? street + `,${component.long_name}`
              : component.long_name;
            break;
          }
          case 'postal_code': {
            zipcode = component.long_name;
            break;
          }
          case 'administrative_area_level_2': {
            city = component.long_name;
            break;
          }
        }
      }
      setTimeout(() => {
        setPropertyInfo({
          ...propertyInfo,
          location: street,
          address: street,
          city: city,
          zipCode: zipcode,
          latitude: lat,
          longitude: lng,
        });
        const addressEle = document.getElementById(
          'propertyAddress',
        ) as HTMLInputElement;
        const cityEle = document.getElementById(
          'propertyCity',
        ) as HTMLInputElement;
        const zipEle = document.getElementById(
          'propertyZip',
        ) as HTMLInputElement;
        if (cityEle) {
          cityEle.value = city;
        }
        if (zipEle) {
          zipEle.value = zipcode;
        }
        if (addressEle) {
          addressEle.value = street;
        }
      }, 200);
    }
    const propAddressEle: any = document.getElementById('propertyAddress');
    if (propAddressEle) {
      propAddressEle.value = street;
    }
  };

  /**
   *
   * @param _value value of purchase price
   */
  const purchasePriceChange = (_value: any): void => {
    if (isTaxVerified && !showed) {
      showed = true;
      setShowTaxModal(true);
    }
    setTransaferTaxAmount(taxCalculation(_value, taxRate ? taxRate : '0'));
    setPropertyDetails({
      ...propertyDetails,
      purchasePrice: _value,
    });
  };

  /**
   *
   * @param stateId selected state
   */
  const getMunicipalities = (stateId: string) => {
    getMunicipalitiesByState({
      variables: { stateId: stateId },
    })
      .then((data: any) => {
        if (data && data.data) {
          const { getActiveMunicipalitiesByState } = data.data;
          const { municipality, success } = getActiveMunicipalitiesByState;
          if (success && municipality && municipality.length) {
            const municipalityOptions = municipality.map(
              (mun: MunicipalityOption) => {
                return {
                  label: mun.name,
                  value: mun.id,
                  ...mun,
                };
              },
            );
            setMunicipalityList(municipalityOptions);
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  };

  /**
   *
   * @param date selected date
   */
  const checkDate = (date: string) => {
    if (municipalityData && municipalityData.inspectionDaysMin && date) {
      const inspectionDays = moment().add(
        municipalityData.inspectionDaysMin,
        'd',
      );
      if (moment(date).isBefore(inspectionDays)) {
        setShowWarning(true);
        return true;
      } else {
        setShowWarning(false);
        return false;
      }
    }
  };

  /**
   *
   * @param event click event
   * @param type type of field changed
   * @param index index of the field changed
   */
  const onChange = (event: any, type?: string, index?: number) => {
    const { name: fieldName, value: fieldValue } =
      (event && event.target) || '';
    if (!/^\s+$/.test(fieldValue)) {
      if (type === 'state') {
        setSelectedState(event);
        getMunicipalities(event._id);
      } else if (type === 'county') {
        setCounty(event);
      } else if (type === 'titleCompany') {
        updateTitleCompany(event);
      } else if (type === 'municipality') {
        setMunicipalityData(event);
        if (event && event.TaxCalculations && event.TaxCalculations.rate) {
          setTaxRate(event.TaxCalculations.rate);
          setTransaferTaxAmount(
            taxCalculation(
              propertyDetails.purchasePrice,
              event.TaxCalculations.rate ? event.TaxCalculations.rate : '0',
            ),
          );
        }
        setCounties(event.counties ? event.counties : []);
        setPropertyInfo({
          ...propertyInfo,
          city: event.city ? event.city : '',
        });
        setCounty(
          event.counties && event.counties.length && event.counties.length === 1
            ? event.counties[0]
            : defaultSelectOption,
        );
        buildAssignmentChecklist(event);
      } else if (type === 'propertytype') {
        setPropertyDetails({
          ...propertyDetails,
          type: event,
        });
      } else if (fieldName === 'propertyAddress') {
        setPropertyInfo({ ...propertyInfo, address: event.target.value });
      } else if (fieldName === 'propertyCity') {
        setPropertyInfo({
          ...propertyInfo,
          city: fieldValue,
        });
      } else if (fieldName === 'propertyState') {
        setPropertyInfo({
          ...propertyInfo,
          state: fieldValue,
        });
      } else if (fieldName === 'propertyZip') {
        setPropertyInfo({
          ...propertyInfo,
          zipCode: fieldValue,
        });
      } else if (fieldName === 'propertyPin') {
        setPropertyDetails({
          ...propertyDetails,
          pin: fieldValue,
        });
      } else if (fieldName === 'propertyPrice') {
        setPropertyDetails({
          ...propertyDetails,
          purchasePrice: fieldValue,
        });
      } else if (fieldName === 'closingDate') {
        if (!checkDate(fieldValue)) {
          setPropertyDetails({
            ...propertyDetails,
            closingDate: fieldValue,
          });
        }
      } else if (fieldName === 'propertyNotes') {
        setPropertyDetails({
          ...propertyDetails,
          notes: fieldValue,
        });
      } else if (fieldName === 'mlsLink') {
        setMlsLink(fieldValue);
      } else if (type === 'creatorType') {
        setCreatorType(event);
        const list: UserTypeOptions[] = [...professionalUsers];
        defCreatorType = event.value;
        regenerateChecklistAssignUsers(list);
      }
      setTimeout(() => {
        propertyInfoRef.current = propertyInfo;
      }, 200);
    }
  };

  const buildAssignmentChecklist = (data: any) => {
    const assignmentChecklistTemp = {};
    Object.assign(assignmentChecklistTemp, {
      verifyTaxCalculations: {
        status: 'PENDING',
        proUser: defaultSelectOption,
      },
    });
    if (
      data &&
      data.includeLegalDescription &&
      data.includeLegalDescription === 'yes'
    ) {
      Object.assign(assignmentChecklistTemp, {
        legalDescription: {
          status: 'PENDING',
          proUser: defaultSelectOption,
        },
      });
    }
    if (data && data.waterReading && data.waterReading.required === 'yes') {
      Object.assign(assignmentChecklistTemp, {
        waterReading: {
          status: 'PENDING',
          proUser: defaultSelectOption,
        },
      });
    }
    if (
      data &&
      data.proofofTaxPayment &&
      data.proofofTaxPayment.required === 'yes'
    ) {
      Object.assign(assignmentChecklistTemp, {
        proofofTaxPayment: {
          status: 'PENDING',
          proUser: defaultSelectOption,
        },
      });
    }
    if (data && data.inspection && data.inspection.required === 'yes') {
      Object.assign(assignmentChecklistTemp, {
        inspection: {
          status: 'PENDING',
          proUser: defaultSelectOption,
        },
      });
    }
    if (
      data &&
      data.additionalQuestions &&
      Array.isArray(data.additionalQuestions) &&
      data.additionalQuestions.length
    ) {
      Object.assign(assignmentChecklistTemp, {
        additionalQuestions: {
          status: 'PENDING',
          proUser: defaultSelectOption,
        },
      });
    }
    setAssignmentCheckList(assignmentChecklistTemp);
  };

  const regenerateChecklistAssignUsers = (
    proUsersListMod: UserTypeOptions[],
    assignmentCheckListData?: any,
  ) => {
    let assignmentUserListTemp = [
      {
        label: defCreatorType + ' - ' + userInfo.displayName,
        value: userInfo.firebaseId,
      },
    ];
    assignmentUserListTemp = assignmentUserListTemp.concat(
      proUsersListMod
        .filter((u: UserTypeOptions) => {
          return u.label && u.user && u.user.name;
        })
        .map((u: UserTypeOptions) => {
          return {
            label: u.label && u.label + ' - ' + u.user.name,
            value:
              u.user && u.user.firebaseId && u.user.firebaseId.length
                ? u.user.firebaseId
                : u.user.email,
          };
        }),
    );
    setAssignmentUserList(assignmentUserListTemp);
    if (assignmentCheckListData) {
      const assignmentChecklistMod: any = {};
      Object.keys(assignmentCheckListData).forEach((key: string) => {
        const checkListData = assignmentCheckListData[key];
        const checkListDataFirebaseId =
          checkListData && checkListData.firebaseId;
        const proUserObj = assignmentUserListTemp.find((p: any) => {
          return p.value === checkListDataFirebaseId;
        });
        if (checkListData) {
          assignmentChecklistMod[key] = {
            status: checkListData && checkListData.status,
            proUser: proUserObj,
          };
        }
      });
      setAssignmentCheckList(assignmentChecklistMod);
    }
  };
  const handleAssignmentChecklist = (
    event: SelectOption,
    checklistAction: string,
  ) => {
    const assignmentChecklistTemp = { ...assignmentCheckList };
    Object.assign(assignmentChecklistTemp, {
      [checklistAction]: {
        status: 'PENDING',
        proUser: event,
      },
    });
    if (transactionId) {
      getAssignmentActivitylog(event, checklistAction);
    }
    setAssignmentCheckList(assignmentChecklistTemp);
  };

  const getAssignmentActivitylog = (userObj: any, taskName: string) => {
    if (taskName === 'legalDescription') {
      activityLog.push({
        transactionId: transactionId,
        firebaseId: userInfo.firebaseId,
        item: `${userObj.label}`,
        description: `has been assigned to Legal Description task by`,
      });
    }
    if (taskName === 'waterReading') {
      activityLog.push({
        transactionId: transactionId,
        firebaseId: userInfo.firebaseId,
        item: `${userObj.label}`,
        description: `has been assigned to Water Reading task by`,
      });
    }
    if (taskName === 'additionalQuestions') {
      activityLog.push({
        transactionId: transactionId,
        firebaseId: userInfo.firebaseId,
        item: `${userObj.label}`,
        description: `has been assigned to Additional Questions task by`,
      });
    }
    if (taskName === 'inspection') {
      activityLog.push({
        transactionId: transactionId,
        firebaseId: userInfo.firebaseId,
        item: `${userObj.label}`,
        description: `has been assigned to Inspection task by`,
      });
    }
    if (taskName === 'proofofTaxPayment') {
      activityLog.push({
        transactionId: transactionId,
        firebaseId: userInfo.firebaseId,
        item: `${userObj.label}`,
        description: `has been assigned to Proof of Tax Payment task by`,
      });
    }
    if (taskName === 'verifyTaxCalculations') {
      activityLog.push({
        transactionId: transactionId,
        firebaseId: userInfo.firebaseId,
        item: `${userObj.label}`,
        description: `has been assigned to Verify Tax Calculations task by`,
      });
    }
  };

  const mapProUserDataFromList = (proUser: UserTypeOptions) => {
    const { user } = proUser;
    const proUserObj = {
      profUserTypeId: proUser.profUserTypeId,
    };
    if (proUser.key) {
      Object.assign(proUserObj, {
        key: proUser.key,
      });
    }
    if (proUser.label) {
      Object.assign(proUserObj, {
        type: proUser.label,
      });
    }

    if (user && user.firebaseId) {
      Object.assign(proUserObj, {
        firebaseId: user.firebaseId,
      });
    } else {
      Object.assign(proUserObj, {
        name: user && user.name ? user.name : '',
        company: user && user.company ? user.company : '',
        email: user && user.email ? user.email : '',
        phone: user && user.phone ? user.phone : '',
      });
    }
    return proUserObj;
  };
  const getAdditionalQuestions = () => {
    const { id, additionalQuestions: aq1 = [] } = municipalityData;
    const {
      assignmentChecklist: assignChecklistSaved = null,
      municipalityId = '',
    } = thisTransaction || {};

    if (!municipalityId || id !== municipalityId) {
      return aq1.map((q: QuesInfo) => {
        return {
          questionId: q.id,
        };
      });
    } else {
      const { additionalQuestions: aq2 = null } = assignChecklistSaved || {};
      const { answers = [] } = aq2 || {};
      return answers.map((ans: QuesInfo) => {
        return {
          questionId: ans.questionId,
          answer: ans.answer,
        };
      });
    }
  };

  const getAssigmentCheckListValues = () => {
    const assignedCheckList: any = {};
    Object.keys(assignmentCheckList).forEach((value: string) => {
      const checkListKey = value as CheckListAction;
      const checkList = (assignmentCheckList &&
        assignmentCheckList[checkListKey]) as CheckList;
      const status = checkList.status || 'PENDING';
      const proUser: any = checkList.proUser;
      const proUserType: string =
        proUser && proUser.label && proUser.label !== 'Please Select'
          ? proUser.label.split('-')[0]
          : '';
      const firebaseId =
        (checkList && checkList.proUser && checkList.proUser.value) || '';
      const checklistObj = { status: status, userType: proUserType };
      if (firebaseId.includes('@')) {
        Object.assign(checklistObj, {
          email: firebaseId,
        });
      } else {
        Object.assign(checklistObj, {
          firebaseId: firebaseId,
        });
      }
      if (checkListKey === 'additionalQuestions') {
        const answers = getAdditionalQuestions();
        Object.assign(checklistObj, {
          answers: answers,
        });
      }
      Object.assign(assignedCheckList, {
        [checkListKey]: checklistObj,
      });
    });
    return assignedCheckList;
  };

  const getSellersActivityLog = (
    prevSellers: string,
    Presentsellers: SellerBuyerInfo[],
  ) => {
    const TempSellers = JSON.parse(prevSellers);
    const oldSellers = Presentsellers.filter(seller => !seller.new);
    if (JSON.stringify(TempSellers.sellers) !== JSON.stringify(oldSellers)) {
      activityLog.push({
        transactionId: transactionId,
        firebaseId: userInfo.firebaseId,
        item: 'Seller Information',
        description: `has been updated by`,
      });
    }
    const newSellers = Presentsellers.filter(seller => seller.new === true);
    newSellers.map(seller => {
      return activityLog.push({
        transactionId: transactionId,
        firebaseId: userInfo.firebaseId,
        item: `${seller.name}`,
        description: `has been added to Sellers by`,
      });
    });
    return activityLog;
  };
  const getBuyersActivityLog = (
    prevBuyer: string,
    PresentBuyers: SellerBuyerInfo[],
  ) => {
    const TempBuyers = JSON.parse(prevBuyer);
    const oldBuyers = PresentBuyers.filter(buyer => !buyer.new);
    if (JSON.stringify(TempBuyers.buyers) !== JSON.stringify(oldBuyers)) {
      activityLog.push({
        transactionId: transactionId,
        firebaseId: userInfo.firebaseId,
        item: 'Buyer Information',
        description: `has been updated by`,
      });
    }
    const newBuyers = PresentBuyers.filter(buyer => buyer.new === true);
    newBuyers.map(buyer => {
      return activityLog.push({
        transactionId: transactionId,
        firebaseId: userInfo.firebaseId,
        item: `${buyer.name}`,
        description: `has been added to Buyers by`,
      });
    });
    return activityLog;
  };
  const getActivityLog = () => {
    const propertyTemp = {
      type: propertyDetails.type.value,
      location: '',
      address: propertyInfo.address,
      city: propertyInfo.city,
      state: 'IL',
      zipCode: propertyInfo.zipCode,
      purchasePrice: propertyDetails.purchasePrice,
      closingDate: propertyDetails.closingDate,
      notes: propertyDetails.notes,
    };
    if (transactionId) {
      if (
        JSON.stringify(thisTransaction.property) !==
        JSON.stringify(propertyTemp)
      ) {
        activityLog.push({
          transactionId: transactionId,
          firebaseId: userInfo.firebaseId,
          item: 'Property Information',
          description: `has been updated by`,
        });
      }
      if (thisTransaction.municipalityData.name !== municipalityData.label) {
        activityLog.push({
          transactionId: transactionId,
          firebaseId: userInfo.firebaseId,
          item: 'Municipality',
          description: `has been updated by`,
        });
      }
      if (
        JSON.stringify(thisTransaction.transactionDocuments) !==
        JSON.stringify(documents)
      ) {
        activityLog.push({
          transactionId: transactionId,
          firebaseId: userInfo.firebaseId,
          item: 'Documents',
          description: `has been updated by`,
        });
      }
      if (
        JSON.stringify(thisTransaction.transactionPayments) !==
        JSON.stringify(payments)
      ) {
        activityLog.push({
          transactionId: transactionId,
          firebaseId: userInfo.firebaseId,
          item: 'Payment Details',
          description: `has been updated by`,
        });
      }
      if (thisTransaction.creator.type !== creatorType.value) {
        activityLog.push({
          transactionId: transactionId,
          firebaseId: userInfo.firebaseId,
          item: 'Person Type ',
          description: ` for ${userInfo.displayName} has been updated by`,
        });
      }
      getSellersActivityLog(thisTransactionStr, sellers);
      getBuyersActivityLog(thisTransactionStr, buyers);
    } else {
      activityLog = [];
      activityLog.push({
        firebaseId: userInfo.firebaseId,
        item: `Transaction`,
        description: 'has been created successfully by',
      });
    }
    return activityLog;
  };

  const setToast = (
    message: string,
    navigatePage?: boolean,
    isEdit?: boolean,
  ) => {
    updateToastMessage(message);
    setShowToast(true);
    setTimeout(() => {
      setShowToast(false);
      setIsError(false);
      if (navigatePage) {
        if (isEdit) {
          navigate('/transactions/details/' + transactionId);
        } else {
          navigate('/transactions');
        }
      }
    }, 1000);
  };
  const offset: number = new Date().getTimezoneOffset();
  const onSubmit = (data: any) => {
    if (removedDocs && removedDocs.length) {
      removedDocs.map((doc: UploadDocType) => {
        return removeDocument(doc);
      });
    }
    if (
      (propertyDetails.purchasePrice &&
        propertyDetails.purchasePrice.split('$')[1] <= 0) ||
      !propertyDetails.purchasePrice ||
      !county.value
    ) {
      return;
    }
    if (payments && payments.length) {
      let emptyCost = payments.filter((payment: PaymentProps) => {
        return !payment.cost;
      });
      if (emptyCost && emptyCost.length) {
        return;
      }
    }
    const mappedSellersList = sellers.map(seller => {
      return {
        address: seller.address,
        name: seller.name,
        phone: seller.phone,
        email: seller.email,
        subDetails: seller.subDetails,
        showRadioButtons: seller.showRadioButtons,
        showEntityCheckbox: seller.showEntityCheckbox,
      };
    });
    const mappedBuyersList = buyers.map(buyer => {
      return {
        address: buyer.address,
        name: buyer.name,
        phone: buyer.phone,
        email: buyer.email,
        subDetails: buyer.subDetails,
        showRadioButtons: buyer.showRadioButtons,
        showEntityCheckbox: buyer.showEntityCheckbox,
      };
    });
    updatesaving(true);
    const resetSubmitActions = () => {
      updatesaving(false);
      updatedisabled(false);
    };
    let transactionVariables = {
      municipalityId: municipalityData.value,
      property: {
        ...propertyInfo,
        countyId: county.value,
        stateId: selectedState._id,
        pin: propertyDetails.pin,
        state: selectedState.label,
        purchasePrice: propertyDetails.purchasePrice,
        closingDate: propertyDetails.closingDate,
        notes: propertyDetails.notes,
        type: propertyDetails.type.value,
      },
      buyers: mappedBuyersList,
      sellers: mappedSellersList,
      professionalUsers:
        professionalUsers && professionalUsers.length
          ? professionalUsers.map(mapProUserDataFromList)
          : [],
      assignmentChecklist: getAssigmentCheckListValues(),
      activityLog: getActivityLog(),
      status: 'OPEN',
      transactionDocuments: documents,
      titleCompany:
        titleCompany && titleCompany.label ? titleCompany.label : '',
      titleCompanyId:
        titleCompany && titleCompany.value ? titleCompany.value : '',
      transactionPaymentsInfo: payments,
      mlsLink: mlsLink,
      offset: offset,
    };
    if (transactionId) {
      Object.assign(transactionVariables, {
        id: transactionId,
      });
      editTransactionDetails({
        variables: transactionVariables,
      })
        .then((res: any) => {
          if (res.data.editTransaction.success) {
            resetSubmitActions();
            setToast('Transaction Updated Succesfully', true, true);
          } else {
            resetSubmitActions();
            setIsError(true);
            setToast(res.data.editTransaction.message);
          }
        })
        .catch((err: any) => {
          resetSubmitActions();
          setIsError(true);
          setToast('Something went wrong...');
        });
    } else {
      Object.assign(transactionVariables, {
        createdBy: userInfo.id,
        creator: {
          type: creatorType.value,
          firebaseId: userInfo.id,
        },
      });
      createTransaction({
        variables: transactionVariables,
      })
        .then((res: any) => {
          if (res.data.createTransaction.success) {
            resetSubmitActions();
            setToast('Transaction Created Succesfully', true);
          } else {
            setIsError(true);
            setToast(res.data.createTransaction.message);
            resetSubmitActions();
          }
        })
        .catch((err: any) => {
          setIsError(true);
          setToast('Something went wrong...');
          resetSubmitActions();
        });
    }
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
        <BackgroundContainer>
          {showTaxModal ? (
            <div>
              <Dialog
                title="Verify Tax Calculations"
                size="small"
                onClose={() => setShowTaxModal(false)}>
                <ModalContent>
                  If you change the Purchase Price it will revert the status of
                  Verify Tax Calculations Checklist
                </ModalContent>
              </Dialog>
            </div>
          ) : null}
          <Toast
            message={toastMessage}
            isError={isError}
            showToast={showToast}
            onClose={() => setShowToast(false)}
          />
          <SecondaryHeader
            showMenuBar={false}
            title={
              transactionId ? 'Edit Transaction' : 'Create New Transaction'
            }
            showCancelButton={true}
            onBackClick={() =>
              navigate(
                transactionId && transactionId.length
                  ? '/transactions/details/' + transactionId
                  : '/transactions',
              )
            }
            onSecondaryButtonClick={() =>
              navigate(
                transactionId && transactionId.length
                  ? '/transactions/details/' + transactionId
                  : '/transactions',
              )
            }
            primaryButtonText="Save Transaction"
            secondaryButtonText="Cancel"
            variant="warning"
            showTransactionSaveButton={true}
            disabledPrimaryButton={disabled}
            saving={saving}
          />
          {transactionId && transactionDetailsLoading ? (
            <Loader>
              <Icon name="loader" />
            </Loader>
          ) : (
            <Container>
              <SideNav userInfo={userInfo} />
              <ListView id="transactionDetailContainer">
                <ListContainer id="municipalityDetails">
                  <PropertyContainer id="propertyDetails">
                    <Title>Property Information</Title>
                    <PropertyBox>
                      <InfoBox>
                        <StateInputCard>
                          <SelectLabel>Type of property</SelectLabel>
                          <Star>*</Star>
                          <Select
                            disabled={!editTransactionPermission}
                            options={propertyOptions}
                            placeholder="Please Select"
                            value={propertyDetails.type}
                            onChange={e => onChange(e, 'propertytype')}
                          />
                          {isSubmitted && !propertyDetails.type.value && (
                            <SelectErrorMessage>
                              Please select Property Type
                            </SelectErrorMessage>
                          )}
                        </StateInputCard>
                        <StateInputCard>
                          <SelectLabel>State</SelectLabel>
                          <Star>*</Star>
                          <Select
                            disabled={
                              transactionStatus === 'INPROGRESS' ||
                              !editTransactionPermission
                            }
                            options={states}
                            placeholder="Please Select"
                            value={selectedState}
                            onChange={e => onChange(e, 'state')}
                            register={register({
                              required: true,
                              name: 'transactionState',
                            })}
                          />
                          {isSubmitted && !selectedState.value && (
                            <SelectErrorMessage>
                              Please select State
                            </SelectErrorMessage>
                          )}
                        </StateInputCard>
                      </InfoBox>
                      <InfoBox>
                        <StateInputCard>
                          <SelectLabel>Municipality</SelectLabel>
                          <Star>*</Star>
                          <Select
                            disabled={
                              transactionStatus === 'INPROGRESS' ||
                              !editTransactionPermission
                            }
                            options={municipalityList}
                            placeholder="Please Select"
                            value={municipalityData}
                            onChange={e => onChange(e, 'municipality')}
                            register={register({
                              required: true,
                              name: 'transactionStatus',
                            })}
                          />
                          {isSubmitted && !municipalityData.value && (
                            <SelectErrorMessage>
                              Please select Municipality
                            </SelectErrorMessage>
                          )}
                        </StateInputCard>
                        <StateInputCard>
                          <SelectLabel>County</SelectLabel>
                          <Star>*</Star>
                          <Select
                            disabled={!editTransactionPermission}
                            options={counties}
                            placeholder="Please Select"
                            value={county}
                            onChange={e => onChange(e, 'county')}
                          />
                          {isSubmitted && county && !county.value ? (
                            <SelectErrorMessage>
                              Please select county
                            </SelectErrorMessage>
                          ) : null}
                        </StateInputCard>
                      </InfoBox>
                      <div>
                        <AddressContainer>
                          <div>
                            <InfoBox>
                              <InputCard
                                onFocus={() =>
                                  setShowDropdown({
                                    type: 'property',
                                    show: true,
                                  })
                                }
                                onBlur={() =>
                                  setShowDropdown({
                                    type: 'property',
                                    show: false,
                                  })
                                }>
                                <Input
                                  label="Street"
                                  star="*"
                                  placeholder="Enter Street"
                                  showDefaultValue={true}
                                  disabled={!editTransactionPermission}
                                  name="propertyAddress"
                                  id="propertyAddress"
                                  value={
                                    propertyInfo.address
                                      ? propertyInfo.address
                                      : ''
                                  }
                                  onChange={onChange}
                                  onKeyDown={(event: any) => {
                                    if (event && event.keyCode === 13) {
                                      event.preventDefault();
                                    }
                                  }}
                                  register={register({
                                    required: 'Please Enter Street',
                                    validate: (value: any) =>
                                      !/^\s+$/.test(value) ||
                                      'Please Enter Street',
                                  })}
                                />
                                {isSubmitted && !propertyInfo.address ? (
                                  <ErrorMessage>
                                    Please enter Street
                                  </ErrorMessage>
                                ) : null}
                              </InputCard>
                              <InputCard>
                                <Input
                                  label="City"
                                  star="*"
                                  disabled={!editTransactionPermission}
                                  id="propertyCity"
                                  showDefaultValue={true}
                                  placeholder="Enter City"
                                  name="propertyCity"
                                  value={
                                    propertyInfo.city ? propertyInfo.city : ''
                                  }
                                  onChange={onChange}
                                  register={register({
                                    required: 'Please Enter City',
                                    validate: (value: any) =>
                                      !/^\s+$/.test(value) ||
                                      'Please Enter City',
                                  })}
                                />
                                {isSubmitted &&
                                errors &&
                                errors.propertyCity ? (
                                  <ErrorMessage>
                                    {errors.propertyCity.message}
                                  </ErrorMessage>
                                ) : null}
                              </InputCard>
                            </InfoBox>
                            <PrimaryInfoBox>
                              <InputCard>
                                <Input
                                  label="Pin"
                                  star="*"
                                  disabled={!editTransactionPermission}
                                  id="proprtyPin"
                                  showDefaultValue={true}
                                  placeholder="Enter Pin"
                                  name="propertyPin"
                                  value={
                                    propertyDetails.pin
                                      ? propertyDetails.pin
                                      : ''
                                  }
                                  onChange={onChange}
                                  register={register({
                                    required: 'Please enter Pin',
                                  })}
                                />
                                {isSubmitted && errors && errors.propertyPin ? (
                                  <ErrorMessage>
                                    {errors.propertyPin.message}
                                  </ErrorMessage>
                                ) : null}
                              </InputCard>
                              <InputCard>
                                <Input
                                  type="number"
                                  label="Zip Code"
                                  star="*"
                                  disabled={!editTransactionPermission}
                                  id="propertyZip"
                                  showDefaultValue={true}
                                  placeholder="Enter Zip"
                                  name="propertyZip"
                                  value={
                                    propertyInfo.zipCode
                                      ? propertyInfo.zipCode
                                      : ''
                                  }
                                  onChange={onChange}
                                  register={register({
                                    required: 'Please enter Zip Code',
                                  })}
                                />
                                {isSubmitted && errors && errors.propertyZip ? (
                                  <ErrorMessage>
                                    {errors.propertyZip.message}
                                  </ErrorMessage>
                                ) : null}
                              </InputCard>
                            </PrimaryInfoBox>
                            <PrimaryInfoBox>
                              <InputCard>
                                <CurrencyInput
                                  disabled={!editTransactionPermission}
                                  label="Purchase Price"
                                  star="*"
                                  placeholder="Enter Purchase Price"
                                  name="propertyPrice"
                                  value={
                                    propertyDetails.purchasePrice
                                      ? propertyDetails.purchasePrice
                                      : ''
                                  }
                                  onChange={(e: any) => purchasePriceChange(e)}
                                  register={register({
                                    required: true,
                                    name: 'propertyPrice',
                                    validate:
                                      propertyDetails.purchasePrice &&
                                      propertyDetails.purchasePrice.length,
                                  })}
                                />
                                {isSubmitted &&
                                ((propertyDetails.purchasePrice &&
                                  propertyDetails.purchasePrice.split('$')[1] <=
                                    0) ||
                                  !propertyDetails.purchasePrice) ? (
                                  <ErrorMessage>
                                    Please enter Purchase Price
                                  </ErrorMessage>
                                ) : null}
                              </InputCard>
                              <PrimaryInputCard>
                                <Input
                                  type="date"
                                  disabled={!editTransactionPermission}
                                  label="Closing Date"
                                  name="closingDate"
                                  value={
                                    propertyDetails.closingDate
                                      ? propertyDetails.closingDate
                                      : ''
                                  }
                                  onChange={onChange}
                                  register={register({})}
                                  min={moment().format('YYYY-MM-DD')}
                                />
                                {showWarning ? (
                                  <ErrorMessage>
                                    It requires minimum{' '}
                                    {municipalityData &&
                                    municipalityData.inspectionDaysMin
                                      ? municipalityData.inspectionDaysMin
                                      : '--'}{' '}
                                    days for the inspection. Please select
                                    another date.
                                  </ErrorMessage>
                                ) : null}
                              </PrimaryInputCard>
                            </PrimaryInfoBox>
                            {propertyDetails.purchasePrice && taxRate ? (
                              <PrimaryInfoBox>
                                <MlsLink>
                                  <Input
                                    type="text"
                                    readOnly={true}
                                    label="Transfer Tax Amount"
                                    placeholder="Show's Transfer Tax Amount"
                                    name="transferTaxAmount"
                                    value={`Transfer tax $${taxCalculation(
                                      propertyDetails.purchasePrice,
                                      taxRate ? taxRate : '0',
                                    )} is applied. $${
                                      taxRate ? taxRate : '0'
                                    } per $1000 of full actual consideration.`}
                                    onChange={onChange}
                                    register={register({})}
                                  />
                                </MlsLink>
                              </PrimaryInfoBox>
                            ) : null}
                            <PrimaryInfoBox>
                              <SecondaryInputCard>
                                <TextArea
                                  label="Notes"
                                  disabled={!editTransactionPermission}
                                  size="106px"
                                  placeholder="Notes (any)"
                                  name="propertyNotes"
                                  value={
                                    propertyDetails.notes
                                      ? propertyDetails.notes
                                      : ''
                                  }
                                  onChange={onChange}
                                  register={register()}
                                />
                              </SecondaryInputCard>
                            </PrimaryInfoBox>
                            <MlsLink>
                              <Input
                                type="text"
                                disabled={!editTransactionPermission}
                                label="MLS Link (optional)"
                                placeholder="Enter URL here"
                                name="mlsLink"
                                value={mlsLink}
                                onChange={onChange}
                                register={register({})}
                              />
                            </MlsLink>
                          </div>
                          <MapContainer
                            disabled={!editTransactionPermission}
                            id="map"
                            style={{ display: 'none' }}></MapContainer>
                        </AddressContainer>
                      </div>
                    </PropertyBox>
                  </PropertyContainer>
                  <DocumentContainer id="documentDetails">
                    <Documents
                      getFiles={getFiles}
                      uploadedDocs={uploadedDocs}
                      afterRemove={afterRemove}
                      firebaseId={
                        userInfo && userInfo.firebaseId
                          ? userInfo.firebaseId
                          : ''
                      }
                      editTransactionPermission={editTransactionPermission}
                    />
                  </DocumentContainer>
                  <InvolvedContainer id="involvedDetails">
                    <Title>Who is Involved?</Title>
                    <Seperator />
                    <SelectItem>
                      <SelectLabel>Title Company</SelectLabel>
                      <Star>*</Star>
                      <Select
                        disabled={!editTransactionPermission}
                        register={register({
                          required: true,
                          name: 'titleCompany',
                        })}
                        name="titleCompany"
                        options={titleCompanies}
                        placeholder="Please Select"
                        value={titleCompany}
                        onChange={e => onChange(e, 'titleCompany')}
                      />
                      {isSubmitted && !titleCompany.value && (
                        <SelectErrorMessage>
                          Please select Title Company
                        </SelectErrorMessage>
                      )}
                    </SelectItem>
                    <DashedSeperator />
                    <InvolvedHeader>
                      {/*  */}
                      <SelectItem>
                        <SelectLabel>You are the…</SelectLabel>
                        <Star>*</Star>
                        <Select
                          disabled={!editTransactionPermission}
                          options={personTypeOptions}
                          placeholder="Please Select"
                          value={creatorType}
                          onChange={e => onChange(e, 'creatorType')}
                        />
                        {isSubmitted && !creatorType.value && (
                          <SelectErrorMessage>
                            Please select Creator Type
                          </SelectErrorMessage>
                        )}
                      </SelectItem>
                    </InvolvedHeader>

                    <InputContainer>
                      <InfoBox>
                        <InputCard>
                          <Input
                            disabled={true}
                            label="Name"
                            placeholder="Enter Name"
                            name="yourName"
                            value={userInfo.displayName || ''}
                            register={register({})}
                          />
                        </InputCard>
                        <InputCard>
                          <Input
                            disabled={true}
                            label="Company"
                            placeholder="Enter Company"
                            name="yourCompany"
                            value={userInfo.company || ''}
                            register={register({})}
                          />
                        </InputCard>
                        <InputCard>
                          <Input
                            disabled={true}
                            label="Email"
                            placeholder="Enter Email"
                            name="yourEmail"
                            value={userInfo.email || ''}
                            register={register({
                              pattern: emailPattern,
                            })}
                          />
                        </InputCard>
                      </InfoBox>
                      <PrimaryInfoBox>
                        <PrimaryInputCard>
                          <Input
                            type="phone_number"
                            disabled={true}
                            label="Phone Number"
                            placeholder="Enter Phone Number"
                            name="yourNumber"
                            value={
                              (userInfo.phone && userInfo.phone.startsWith('+1')
                                ? userInfo.phone.substring(2)
                                : userInfo.phone) || ''
                            }
                            register={register({})}
                          />
                        </PrimaryInputCard>
                      </PrimaryInfoBox>
                    </InputContainer>
                    <BuyerContainer>
                      <Seperator />
                      <Heading>Buyer Details* </Heading>
                      <SellerBuyerDetails
                        isSubmitted={isSubmitted}
                        errors={errors}
                        register={register}
                        users={buyers}
                        setUsers={setBuyers}
                        transactionId={transactionId}
                        userType={'buyer'}
                      />
                    </BuyerContainer>
                    <SellerContainer>
                      <Seperator />
                      <Heading>Seller Details* </Heading>
                      <SellerBuyerDetails
                        isSubmitted={isSubmitted}
                        errors={errors}
                        register={register}
                        users={sellers}
                        setUsers={setSellers}
                        transactionId={transactionId}
                        userType={'seller'}
                      />
                    </SellerContainer>
                    <ProUserContainer>
                      <Seperator />
                      <Heading>Professional Users Details* </Heading>
                      <ProfessionalUsers
                        activityLog={activityLog}
                        professionalUsers={
                          transactionId ? professionalUsers : profUserOptions
                        }
                        profUserOptions={profUserOptions}
                        register={register}
                        errors={errors}
                        isSubmitted={isSubmitted}
                        setProfessionalUsers={setProfessionalUsers}
                        regenerateChecklistAssignUsers={
                          regenerateChecklistAssignUsers
                        }
                        transactionId={transactionId}
                      />
                    </ProUserContainer>
                    <SecondarySeperator />
                  </InvolvedContainer>
                  <CheckListContainer id="checklistDetails">
                    <Title>Assignment Checklist</Title>
                    <CheckListBox>
                      {municipalityData &&
                        municipalityData.includeLegalDescription === 'yes' && (
                          <PersonTypeCard>
                            <PrimarySelectLabel>
                              Legal Description
                            </PrimarySelectLabel>
                            <Select
                              disabled={
                                (assignmentCheckList.legalDescription &&
                                  assignmentCheckList.legalDescription
                                    .status === 'COMPLETED') ||
                                !checkEditTaskPermission(
                                  userInfo,
                                  (assignmentCheckList.legalDescription &&
                                    assignmentCheckList.legalDescription
                                      .proUser) ||
                                    [],
                                )
                              }
                              options={assignmentUserList}
                              placeholder="Please Select"
                              value={
                                assignmentCheckList.legalDescription &&
                                assignmentCheckList.legalDescription.proUser
                              }
                              onChange={e =>
                                handleAssignmentChecklist(e, 'legalDescription')
                              }
                            />
                          </PersonTypeCard>
                        )}
                      <PersonTypeCard>
                        <PrimarySelectLabel>
                          Verify Tax Calculations
                        </PrimarySelectLabel>
                        <Select
                          disabled={
                            (assignmentCheckList.verifyTaxCalculations &&
                              assignmentCheckList.verifyTaxCalculations
                                .status === 'COMPLETED') ||
                            !checkEditTaskPermission(
                              userInfo,
                              (assignmentCheckList.verifyTaxCalculations &&
                                assignmentCheckList.verifyTaxCalculations
                                  .proUser) ||
                                [],
                            )
                          }
                          options={assignmentUserList}
                          placeholder="Please Select"
                          value={
                            assignmentCheckList.verifyTaxCalculations &&
                            assignmentCheckList.verifyTaxCalculations.proUser
                          }
                          onChange={e =>
                            handleAssignmentChecklist(
                              e,
                              'verifyTaxCalculations',
                            )
                          }
                        />
                      </PersonTypeCard>
                      {municipalityData &&
                        municipalityData.waterReading &&
                        municipalityData.waterReading.required === 'yes' && (
                          <PersonTypeCard>
                            <PrimarySelectLabel>
                              Water Reading
                            </PrimarySelectLabel>
                            <Select
                              disabled={
                                (assignmentCheckList.waterReading &&
                                  assignmentCheckList.waterReading.status ===
                                    'COMPLETED') ||
                                !checkEditTaskPermission(
                                  userInfo,
                                  (assignmentCheckList.waterReading &&
                                    assignmentCheckList.waterReading.proUser) ||
                                    [],
                                )
                              }
                              options={assignmentUserList}
                              placeholder="Please Select"
                              value={
                                assignmentCheckList.waterReading &&
                                assignmentCheckList.waterReading.proUser
                              }
                              onChange={e =>
                                handleAssignmentChecklist(e, 'waterReading')
                              }
                            />
                          </PersonTypeCard>
                        )}
                      {municipalityData &&
                        municipalityData.inspection &&
                        municipalityData.inspection.required === 'yes' && (
                          <PersonTypeCard>
                            <PrimarySelectLabel>Inspection</PrimarySelectLabel>
                            <Select
                              disabled={
                                (assignmentCheckList.inspection &&
                                  assignmentCheckList.inspection.status ===
                                    'COMPLETED') ||
                                !checkEditTaskPermission(
                                  userInfo,
                                  (assignmentCheckList.inspection &&
                                    assignmentCheckList.inspection.proUser) ||
                                    [],
                                )
                              }
                              options={assignmentUserList}
                              placeholder="Please Select"
                              value={
                                assignmentCheckList.inspection &&
                                assignmentCheckList.inspection.proUser
                              }
                              onChange={e =>
                                handleAssignmentChecklist(e, 'inspection')
                              }
                            />
                          </PersonTypeCard>
                        )}
                      {municipalityData &&
                      municipalityData.additionalQuestions &&
                      municipalityData.additionalQuestions.length ? (
                        <PersonTypeCard>
                          <PrimarySelectLabel>
                            Additional Questions
                          </PrimarySelectLabel>
                          <Select
                            disabled={
                              (assignmentCheckList.additionalQuestions &&
                                assignmentCheckList.additionalQuestions
                                  .status === 'COMPLETED') ||
                              !checkEditTaskPermission(
                                userInfo,
                                (assignmentCheckList.additionalQuestions &&
                                  assignmentCheckList.additionalQuestions
                                    .proUser) ||
                                  [],
                              )
                            }
                            options={assignmentUserList}
                            placeholder="Please Select"
                            value={
                              assignmentCheckList.additionalQuestions &&
                              assignmentCheckList.additionalQuestions.proUser
                            }
                            onChange={e =>
                              handleAssignmentChecklist(
                                e,
                                'additionalQuestions',
                              )
                            }
                          />
                        </PersonTypeCard>
                      ) : null}
                      {municipalityData &&
                        municipalityData.proofofTaxPayment &&
                        municipalityData.proofofTaxPayment.required ===
                          'yes' && (
                          <PersonTypeCard>
                            <PrimarySelectLabel>
                              Proof of Tax Payment
                            </PrimarySelectLabel>
                            <Select
                              disabled={
                                (assignmentCheckList.proofofTaxPayment &&
                                  assignmentCheckList.proofofTaxPayment
                                    .status === 'COMPLETED') ||
                                !checkEditTaskPermission(
                                  userInfo,
                                  (assignmentCheckList.proofofTaxPayment &&
                                    assignmentCheckList.proofofTaxPayment
                                      .proUser) ||
                                    [],
                                )
                              }
                              options={assignmentUserList}
                              placeholder="Please Select"
                              value={
                                assignmentCheckList.proofofTaxPayment &&
                                assignmentCheckList.proofofTaxPayment.proUser
                              }
                              onChange={e =>
                                handleAssignmentChecklist(
                                  e,
                                  'proofofTaxPayment',
                                )
                              }
                            />
                          </PersonTypeCard>
                        )}
                    </CheckListBox>
                    <SecondarySeperator />
                  </CheckListContainer>
                  <PaymentDueContainer id="paymentDueDetails">
                    <Title>Payment Due</Title>
                    <PaymentDue
                      isSubmitted={isSubmitted}
                      errors={errors}
                      register={register}
                      payments={payments}
                      showAdd={true}
                      setCostItems={setPayments}
                      userInfo={userInfo}
                      allowEdit={true}
                      fromCreateTab={transactionId ? false : true}
                      transactionId={transactionId}
                      transferTaxAmount={transferTaxAmount}
                      addTaxCostItem={{
                        add:
                          propertyDetails.purchasePrice &&
                          taxRate &&
                          !transactionId
                            ? true
                            : false,
                        amount: transferTaxAmount
                          ? transferTaxAmount
                          : taxCalculation(
                              propertyDetails.purchasePrice,
                              taxRate ? taxRate : '0',
                            ),
                      }}
                    />
                  </PaymentDueContainer>
                  <SaveButtonBox>
                    <CancelButton
                      onClick={() =>
                        navigate(
                          transactionId && transactionId.length
                            ? '/transactions/details/' + transactionId
                            : '/transactions',
                        )
                      }>
                      Cancel
                    </CancelButton>
                    <ButtonItem disabled={disabled}>
                      <Button
                        variant="warning"
                        size="medium"
                        width="100%"
                        type="submit">
                        Save
                      </Button>
                    </ButtonItem>
                  </SaveButtonBox>
                </ListContainer>
              </ListView>
            </Container>
          )}
        </BackgroundContainer>
      </form>
    </>
  );
}
export function removeDocument(document: UploadDocType) {
  var params = {
    Bucket: s3BucketName,
    Key: document.docKey,
  };
  s3.deleteObject(params, function(err, data) {
    if (err) console.log(err, err.stack);
    else {
    }
  });
}
